// extracted by mini-css-extract-plugin
export var fadeIn = "_f2-1";
export var modalContent = "_f2-3";
export var overlay = "_f2-0";
export var popoverContent = "_f2-2";
export var results = "_f2-5";
export var searchInputWrapper = "_f2-4";